<template>
    <div>
        <div v-if="dmMessageMode === 'group'" class="section">
            <div class="toolbar">
                <ans-input
                    id="Keyword"
                    v-model="data.groupKeyWord"
                    type="text"
                    :max-length="100"
                    placeholder="グループ名で検索"
                    is-enable-i-m-e
                    item-class="width-400-px"
                    input-class="custom-border"
                />
                <button class="search-btn" @click="$emit('search-group')">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                        ></path>
                    </svg>
                </button>
                <button class="clear-btn" @click="data.groupKeyWord = ''">クリア</button>
            </div>

            <div class="p-20 v-card v-sheet v-sheet--outlined theme--light mt-3">
                <div class="detail mx-0 mt-2">
                    <div class="table-scroll">
                        <table class="main-table table-list table-bordered table-width align-table">
                            <thead>
                                <tr>
                                    <th class="text-center width-50-px" @click="$emit('open-detail', '')">
                                        <i class="fa-solid fa-plus cursor-pointer"></i>
                                    </th>
                                    <th class="text-center min-width-250-px">グループ名</th>
                                    <th class="text-center width-100-px">並順</th>
                                    <th class="text-center width-100-px">表示区分</th>
                                    <th class="text-center width-100-px">メンバー数</th>
                                    <th class="text-center width-100-px">操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="data.listGroup.length > 0">
                                    <tr v-for="(item, index) in data.listGroup" :key="item.GroupID || item.No || index">
                                        <td class="text-start">
                                            <span class="staff-id">{{ item.No }}</span>
                                        </td>
                                        <td class="text-start">{{ item.GroupName }}</td>
                                        <td class="text-center">{{ item.LineNo }}</td>
                                        <td class="text-center">{{ item.ShowTypeName }}</td>
                                        <td class="text-center">{{ item.MemberCount }}</td>
                                        <td class="text-center">
                                            <span class="edit mr-10-px" @click="$emit('open-detail', item)"><i class="fa-solid fa-pencil"></i></span>
                                            <span class="delete" @click="$emit('delete-group', item)"><i class="fa-solid fa-trash"></i></span>
                                        </td>
                                    </tr>
                                </template>
                                <tr v-else class="msg_no_data">
                                    <td colspan="6" class="text-center">該当するデータが存在しません。</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="section">
            <div class="field-item">
                <div class="lable_item">グループ名</div>
                <div class="item-group">
                    <div class="w-100">
                        <ans-input
                            id="GroupName"
                            v-model="data.groupDetail.GroupName"
                            type="text"
                            placeholder="例: グループA"
                            :max-length="50"
                            :isEnableIME="true"
                            input-class="custom-border"
                            is-required
                        />
                    </div>
                </div>
            </div>
            <div class="field-item mt-10-px">
                <div class="lable_item">並順</div>
                <div class="item-group">
                    <div class="w-25">
                        <ans-input v-model="data.groupDetail.LineNo" type="number" :max-length="2" input-class="custom-border" is-disabled />
                    </div>
                </div>
            </div>
            <div class="field-item mt-10-px">
                <div class="lable_item">表示区分</div>
                <div class="item-group">
                    <div class="w-100">
                        <ans-select v-model="data.groupDetail.ShowType" :options="options.ShowType" remove-empty-option input-class="custom-border" />
                    </div>
                </div>
            </div>

            <div class="line-border-bottom mt-20-px"><label class="control-label">メンバー</label></div>

            <MemberGroupTable
                @add-new-member="$emit('add-new-member')"
                @delete-member="$emit('delete-member', $event)"
                @move-up="$emit('move-up', $event)"
                @move-down="$emit('move-down', $event)"
                @refer-employee="forwardReferEmployee"
                @get-employee-name="forwardGetEmployeeName"
            />

            <div class="footer-actions">
                <ans-button label="キャンセル" class="clear-btn" style="width: 110px !important" @click="$emit('back-list')" />
                <ans-button label="保存" class="search-btn" style="width: 60px !important" @click="submitGroup" :is-disabled="!canSubmitGroup" />
            </div>
        </div>
    </div>
</template>

<script>
import MemberGroupTable from './MemberGroupTable.vue';
import { mapMutations, mapState } from 'vuex';
import { MSG_TITLE, MSG_TYPE } from '@/utils/messages';

export default {
    name: 'GroupManagementSection',
    components: { MemberGroupTable },
    props: {},
    data() {
        return {
            errors: []
        };
    },
    computed: {
        ...mapState('app', ['user', 'isShowLeftMenu', 'dmMessageMode']),
        ...mapState('MNG_DM_Message_Store', ['data', 'options']),
        canSubmitGroup() {
            const groupName = this.data?.groupDetail?.GroupName;
            const members = this.data?.groupDetail?.members || [];

            const hasGroupName = !!String(groupName || '').trim();
            const hasValidMembers = members.length > 0 && members.every((member) => !!String(member?.EmployeeCD || '').trim());

            return hasGroupName && hasValidMembers;
        }
    },
    methods: {
        ...mapMutations('app', ['showModalMessage', 'hideModalMessage']),
        forwardReferEmployee(index, value, item) {
            this.$emit('refer-employee', index, value, item);
        },
        forwardGetEmployeeName(value, item) {
            this.$emit('get-employee-name', value, item);
        },
        duplicateEmployeeIndexes() {
            const members = this.data?.groupDetail?.members || [];

            const map = {};

            this.errors = [];

            members.forEach((m, index) => {
                const key = String(m?.EmployeeCD || '').trim();
                if (!key) return;

                if (!map[key]) {
                    map[key] = [index];
                } else {
                    map[key].push(index);
                }
            });

            Object.values(map).forEach((indexes) => {
                if (indexes.length > 1) {
                    indexes.forEach((idx) => {
                        this.errors.push({
                            name: 'EmployeeCD' + idx,
                            message: ''
                        });
                    });
                }
            });
        },
        submitGroup() {
            this.duplicateEmployeeIndexes();
            if (this.errors.length > 0) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.S001,
                    content: '社員コードが重複しています。',
                    okText: 'OK',
                    callback: () => {
                        document.getElementById(this.errors[0].name).focus();
                    }
                });
                return;
            }
            this.$emit('submit');
        }
    }
};
</script>
